import React, {useEffect, useState, useRef} from "react";
import CustomSpan from "../../components/CustomSpan";
import Table from "../../components/table/Table";
import {FiUser, FiCalendar} from "react-icons/fi";
import {Label} from "../form/labels";
import {formatDateTime} from "../../utils/datetime-utils";
import {
  getInspectionResutlBackground,
  getInspectionResutlColor, getInspectionResutlSymbol, getInspectionUnit
} from "../../utils/display-utils";
import {InspectionResultWithUnit, RemarkDetail} from "../inspection";
import {useSelector} from "react-redux";
import ReadonlyComment from "../ReadonlyComment"
import { JudgmentLimit } from "../judgment";

function TreatmentDetail(props) {
  const {
    treatmentNumber,
    treatmentUser,
    treatmentDatetime,
    treatmentLog,
    inspectionItem,
    hasTreatment,
    active,
    remarkText=null,
    commentFiles=null,
  } = props;
  const resultSymbolSetting = useSelector(
    (s) => s.app_settings.inspection_display.inspection_result_symbol
  );
  const [maxHeight, setMaxHeight] = useState(null);
  const tableRef= useRef(null);

  useEffect(() => {
    if (!tableRef.current || !treatmentLog || treatmentLog.length < 11 || !active) {
      setMaxHeight(null);
      return;
    }

    const thead = tableRef.current.querySelector("thead");
    const theadHeight = thead ? thead.offsetHeight : 0;

    const filteredTreatmentLog = treatmentLog.filter((itemLog) => {
      const matchInspectionItem = inspectionItem.find(
        (result) => result.id === (hasTreatment ? Number(itemLog.inspection_item_id) : Number(itemLog.inspection_item?.id))
      );
      if (!matchInspectionItem) return false;
      if (treatmentNumber === 0 && Number(itemLog.result) !== 0) return false;
      return true
    });

    if (filteredTreatmentLog.length < 11) {
      setMaxHeight(null);
      return;
    }

    const rows = tableRef.current.querySelectorAll("tbody tr");
    let rowsHeight = 0;
    for (let i = 0; i < Math.min(10, rows.length); i++) {
      rowsHeight += rows[i].offsetHeight;
    }
    setMaxHeight(theadHeight + rowsHeight)

  }, [active, treatmentNumber]);

  return (
    <div className="flex flex-col px-[10px] gap-[20px]">
      <div className="px-2.5 self-stretch flex item-center gap-[40px]">
        <CustomSpan className="font-medium text-gray-900 text-center" text={`処置${treatmentNumber}回目`}/>
        <div className="flex items-center gap-[10px]">
          <FiUser size={20} className="font-medium"/>
          <CustomSpan className="font-medium text-gray-900 text-center" text={treatmentUser?.name}/>
        </div>
        <div className="flex items-center gap-[10px]">
          <FiCalendar size={20} className="font-medium"/>
          <CustomSpan className="font-medium text-gray-900 text-center"
                      text={formatDateTime(new Date(treatmentDatetime))}/>
        </div>
      </div>
      <div className="w-full relative rounded-lg border border-[#e0e0e0] overflow-y-auto" style={{
        maxHeight: maxHeight ? `${maxHeight}px` : "auto"
      }} ref={tableRef}>
        <Table className="no-drop-shadow-table" striped>
          <Table.Head className={`${maxHeight ? 'sticky top-0 z-[8]' : ''} border-b border-tenken-gray-200`}>
            <Table.HeadCell className="!normal-case w-[76px] scrollable-table-header-bg">
              <span>No.</span>
            </Table.HeadCell>
            <Table.HeadCell className="max-w-[938px] scrollable-table-header-bg">
              <span className="whitespace-nowrap">点検項目</span>
            </Table.HeadCell>
            <Table.HeadCell className="scrollable-table-header-bg">
              <span className="whitespace-nowrap">判定基準</span>
            </Table.HeadCell>
            <Table.HeadCell className="scrollable-table-header-bg">
              <span className="whitespace-nowrap">下限</span>
            </Table.HeadCell>
            <Table.HeadCell className="scrollable-table-header-bg">
              <span className="whitespace-nowrap">上限</span>
            </Table.HeadCell>
            <Table.HeadCell className="scrollable-table-header-bg"></Table.HeadCell>
            <Table.HeadCell className="scrollable-table-header-bg">
              <span className="whitespace-nowrap">留意事項</span>
            </Table.HeadCell>
            <Table.HeadCell className="scrollable-table-header-bg">
              <span className="whitespace-nowrap">点検結果</span>
            </Table.HeadCell>
          </Table.Head>
          <Table.Body className="devide-y text-base break-all">
            {treatmentLog && treatmentLog.map((itemLog, index) => {
              const matchInspectionItem = inspectionItem.find(
                (result) => result.id === (hasTreatment ? Number(itemLog.inspection_item_id) : Number(itemLog.inspection_item_id))
              );
              if (!matchInspectionItem) {
                return null;
              }
              if (treatmentNumber === 0 && Number(itemLog.result) !== 0) {
                return null
              }
              return (
                <Table.Row key={index}
                           className="odd:bg-gray-50 even:bg-white odd:dark:bg-gray-70 even:dark:bg-gray-800 border-b border-tenken-gray-200">
                  <Table.Cell>
                    <span>{matchInspectionItem.item_order}</span>
                  </Table.Cell>
                  <Table.Cell className="max-w-[400px]">
                    <span 
                      style={{color: matchInspectionItem.title_color}}
                      className="break-all"
                    >
                      {matchInspectionItem.title}
                    </span>
                  </Table.Cell>
                  <Table.Cell className="max-w-[300px]">
                      <span 
                        style={{color: matchInspectionItem.description_color}}
                        className="break-all"
                      >
                        {matchInspectionItem.description}
                      </span>
                  </Table.Cell>
                  <Table.Cell className="max-w-[300px]">
                    <JudgmentLimit
                      value={matchInspectionItem.inspection_judgment?.lower_value}
                      boundaryType={matchInspectionItem.inspection_judgment?.lower_boundary_type}
                      unit={matchInspectionItem.unit}
                      type="lower"
                    />
                  </Table.Cell>
                  <Table.Cell className="max-w-[300px]">
                    <JudgmentLimit
                      value={matchInspectionItem.inspection_judgment?.upper_value}
                      boundaryType={matchInspectionItem.inspection_judgment?.upper_boundary_type}
                      unit={matchInspectionItem.unit}
                      type="upper"
                    />
                  </Table.Cell>
                  <Table.Cell className="px-2">
                    <CustomSpan 
                      title={matchInspectionItem.unit}
                      className="whitespace-nowrap"
                    >
                      {matchInspectionItem.unit ? getInspectionUnit(matchInspectionItem.unit, true) : '-'}
                    </CustomSpan>
                  </Table.Cell>
                  <Table.Cell>
                    <RemarkDetail key={index} rowData={matchInspectionItem}/>
                  </Table.Cell>
                  <Table.Cell className="max-w-[300px]">
                    <span
                      style={{
                        color: getInspectionResutlColor(
                          Number(itemLog.result),
                          resultSymbolSetting
                        ),
                      background: getInspectionResutlBackground(
                        Number(itemLog.result),
                        resultSymbolSetting
                      ),
                      }}>
                        {getInspectionResutlSymbol(
                          Number(itemLog.result),
                          resultSymbolSetting,
                        )}
                      </span>
                      {matchInspectionItem.inspection_item_type?.name === 'input' && (
                        <InspectionResultWithUnit 
                          inspectionResult={itemLog.inspection_item_value}
                          unit={matchInspectionItem.unit}
                          className="ml-1"
                        />
                      )}
                  </Table.Cell>
                </Table.Row>
              )
            })}
          </Table.Body>
        </Table>
      </div>
      <div className="flex flex-col bg-[#FFF] items-start self-stretch w-full xl:gap-[16px] gap-[12px]">
        <Label className="font-medium" text='処置コメント'/>
        <ReadonlyComment
          remarkText={remarkText}
          commentFiles={commentFiles}
          className={treatmentNumber === 0 ? 'bg-[#EEE]' : ''}
        />
      </div>
    </div>
  );
}

export default TreatmentDetail;
